import { IChat, IUser } from "@/lib/types";
import React from "react";

export interface IUserContext {
    user: IUser | undefined;
    updateUser: (user: IUser | undefined) => void;
}

export interface IChatsContext {
    chats: IChat[];
    updateChat: (chat: IChat) => Promise<void>;
    deleteChat: (id: string) => Promise<void>;
}

export interface ICurrentChatContext {
    currentChat: IChat | undefined;
    updateCurrentChat: (chat: IChat | undefined) => void;
}

export const UserContext = React.createContext<IUserContext>({
    user: undefined,
    updateUser: () => {},
});

export const ChatsContext = React.createContext<IChatsContext>({
    chats: [],
    updateChat: async () => {},
    deleteChat: async () => {},
});

export const CurrentChatContext = React.createContext<ICurrentChatContext>({
    currentChat: undefined,
    updateCurrentChat: () => {},
});
